// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__YIPH_","left":"StickyBox_left__1U5s8","right":"StickyBox_right__3X-zM"};